import AccountApi from 'ea-account-api/index';
import { getAccessToken, msalInstance } from '../auth';

export const accountApi = new AccountApi(process.env.ACCOUNT_API_URL!, () =>
  getAccessToken(msalInstance)
);
